export default {
  "b2b.autocompletes.doplnkove-sluzby.label": "Dolňková služba",
  "b2b.autocompletes.doplnkove-sluzby.label-multiple": "Dolňkové služby",
  "b2b.autocompletes.doplnkove-sluzby.placeholder": "vyberte doplňkovou službu",
  "b2b.autocompletes.doplnkove-sluzby.placeholder-multiple":
    "vyberte doplňkové služby",
  "b2b.autocompletes.zakaznici.label": "Zákazník",
  "b2b.autocompletes.zakaznici.placeholder": "vyberte zákazníka",
  "b2b.autocompletes.uzivatele.label": "Uživatel",
  "b2b.autocompletes.uzivatele.placeholder": "vyberte uživatele",
  "b2b.autocompletes.projekty.label": "Projekt",
  "b2b.autocompletes.projekty.placeholder": "vyberte projekt",
  "b2b.autocompletes.produkty.label": "Produkt",
  "b2b.autocompletes.produkty.label-multiple": "Produkty",
  "b2b.autocompletes.produkty.placeholder": "vyberte produkt",
  "b2b.autocompletes.produkty.placeholder-multiple": "vyberte produkty",
  "b2b.autocompletes.smlouvy.label": "Smlouva",
  "b2b.autocompletes.smlouvy.placeholder": "vyberte smlouvu",
  "b2b.autocompletes.zdroj.label": "Zdroj",
  "b2b.autocompletes.zdroj.placeholder": "vyberte zdroj",
  "b2b.autocompletes.zadosti-stav.label": "Stav žádosti",
  "b2b.autocompletes.zadosti-stav.placeholder": "vyberte stav žádosti"
};
